const packageName = process.env._PACKAGE_NAME_;
const packageVersion = process.env._PACKAGE_VERSION_;

export const BUILD_VERSION = `${packageName}@${packageVersion}`;
export const ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
export const FEEDBACK_CONTEXT_CF = 'customfield_10047';
export const SOURCE = 'search-page';
